import { createContext, useContext } from 'react';

export const ProductContext = createContext({});

export const useProductContext = () => useContext(ProductContext);

export const ProductProvider = ({ components = {}, children }) => {
  return (
    <ProductContext.Provider value={components}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContext;
